(() => {
  const SELECTORS = [
    '.banner__heading',
    '.collection-hero__title',
    '.mc-collection-products-heading',
    '.collection-card-wrapper .card__heading',
    '.collection-list .card__heading',
    '.collection__title .title',
    '.collection-list-title',
    '.image-with-text__heading',
    '.multicolumn__title .title',
    '.collapsible-content__heading',
    '.cv-title',
    '.ds-title',
    '.rich-text__heading'
  ];

  const STYLES = ['underline', 'double', 'squiggle', 'zigzag'];
  const DEFAULT_STYLE = 'underline';
  const DEFAULT_COLOR = '#FF4F00';

  function svg(style) {
    if (style === 'double') {
      return '<svg class="vco-marker-svg vco-marker-svg--double" viewBox="0 0 120 18" preserveAspectRatio="none" aria-hidden="true" focusable="false"><path d="M3 8 C 25 11, 48 4.5, 72 7.5 C 92 10, 105 7.8, 117 5.8" fill="none" stroke="currentColor" stroke-width="2.4"/><path d="M6 14 C 30 16.5, 55 10.8, 78 13 C 94 14.6, 106 12.8, 115 11" fill="none" stroke="currentColor" stroke-width="2"/></svg>';
    }
    if (style === 'zigzag') {
      return '<svg class="vco-marker-svg vco-marker-svg--zigzag" viewBox="0 0 120 16" preserveAspectRatio="none" aria-hidden="true" focusable="false"><path d="M3 11 L13 5 L23 11 L33 5 L43 11 L53 5 L63 11 L73 5 L83 11 L93 5 L103 11 L117 5" fill="none" stroke="currentColor" stroke-width="2.8"/></svg>';
    }
    if (style === 'squiggle') {
      return '<svg class="vco-marker-svg vco-marker-svg--squiggle" viewBox="0 0 120 18" preserveAspectRatio="none" aria-hidden="true" focusable="false"><path d="M2 10 C 8 3, 15 3, 21 10 S 34 17, 40 10 S 53 3, 59 10 S 72 17, 78 10 S 91 3, 97 10 S 110 17, 118 10" fill="none" stroke="currentColor" stroke-width="2.8"/></svg>';
    }
    return '<svg class="vco-marker-svg vco-marker-svg--underline" viewBox="0 0 120 14" preserveAspectRatio="none" aria-hidden="true" focusable="false"><path d="M4 10.4 C 22 11.2, 39 10.2, 56 8.8 C 74 7.3, 94 7.9, 116 8.7" fill="none" stroke="currentColor" stroke-width="3.2"/></svg>';
  }

  function escapeHtml(value) {
    return value.replace(/[&<>'"]/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[char]));
  }

  function parseMarkedPart(raw) {
    const match = raw.trim().match(/^(underline|double|squiggle|zigzag)\s*:\s*(.+)$/i);
    if (match) return { style: match[1].toLowerCase(), text: match[2] };
    return { style: DEFAULT_STYLE, text: raw };
  }

  function decorate(el) {
    if (!el || el.dataset.vcoMarkerAuto === 'done') return;
    if (el.querySelector('.vco-marker-word')) return;

    const text = el.textContent || '';
    if (!text.includes('|')) return;

    const parts = text.split('|');
    if (parts.length < 3) return;

    let html = '';
    parts.forEach((part, index) => {
      if (index % 2 === 1) {
        const parsed = parseMarkedPart(part);
        const style = STYLES.includes(parsed.style) ? parsed.style : DEFAULT_STYLE;
        html += '<span class="vco-marker-word vco-marker-word--' + style + '" style="--vco-marker-color: ' + DEFAULT_COLOR + ';"><span class="vco-marker-word__text">' + escapeHtml(parsed.text) + '</span>' + svg(style) + '</span>';
      } else {
        html += escapeHtml(part);
      }
    });

    el.classList.add('vco-marker-heading');
    el.innerHTML = html;
    el.dataset.vcoMarkerAuto = 'done';
  }

  function run(root = document) {
    if (!root || !root.querySelectorAll) root = document;
    root.querySelectorAll(SELECTORS.join(',')).forEach(decorate);
  }

  function boot() {
    run();
    setTimeout(run, 250);
    setTimeout(run, 800);
    setTimeout(run, 1600);

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) run(node);
          });
        }
        if (mutation.type === 'characterData' && mutation.target.parentElement) {
          const parent = mutation.target.parentElement.closest(SELECTORS.join(','));
          if (parent && parent.dataset.vcoMarkerAuto !== 'done') decorate(parent);
        }
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => run(event.target));
  document.addEventListener('shopify:block:select', (event) => run(event.target));
})();
